import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampanhaDestaqueService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  list(params?: any): Observable<any> {
    return this.apiService.get(`/CampanhaDestaque`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `/CampanhaDestaque/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  removeDestaque(id: number): Observable<any> {
    return this.apiService.patch(`/CampanhaDestaque/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  // get photo Empresa do sector
  getPhotoCampanhaByID(id: number): Observable<Blob> {
    return this.apiService.get(`/Anexo/Ficheiro/${id}`, undefined, 'blob');
  }

  /**
    * Cria uma nova Campanha
    * @param campanha FormData contendo os dados da Campanha
    * @returns Observable<any>
    */
  public store(campanha: any): Observable<any> {
    return this.apiService.post(`/CampanhaDestaque`, campanha);
  }
}
